import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ExternalLinkIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {SemanticSearchPropertyDto} from "../../types/SemanticSearchPropertyDto";
import {SemanticSearchConversationVoteButtons} from "../semantic_search_conversation/SemanticSearchConversationVoteButtons";

interface Props {
    properties?: SemanticSearchPropertyDto[][];
    apiMessageIndex: number;
}

function flattenProperties(properties: SemanticSearchPropertyDto[][]): SemanticSearchPropertyDto[] {
    return properties.flatMap((group) => group);
}

export function SemanticSearchPropertyList(props: Props) {
    const {properties, apiMessageIndex} = props;

    if (!properties || properties.length === 0) return null;

    const items = flattenProperties(properties);

    return (
        <ul className={list}>
            {items.map((property, index) => {
                const propertyLink = rpAppLink.property.detail.base({
                    vendorSlug: property.offer.vendor.slug,
                    offerSlug: property.offer.slug,
                    offerId: property.offer.id,
                    propertyId: property.id
                });

                return (
                    <li key={`${property.id}-${index}`} className={listItem}>
                        <a className={itemLinkOverlay} href={propertyLink} target="_blank" rel="noopener noreferrer" aria-label="Zobacz ofertę" />

                        <div className={itemContent}>
                            <span className={bulletDot} aria-hidden="true" />

                            <div className={contentWrapper}>
                                <Text variant="body_copy_1" as="span" className={firstLine}>
                                    {property.short_description}
                                </Text>

                                <div className={interactiveLayer}>
                                    <SemanticSearchConversationVoteButtons id={property.id} apiMessageIndex={apiMessageIndex} />
                                </div>
                            </div>

                            <Button
                                variant="none_secondary"
                                className={externalLinkButton}
                                href={propertyLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Zobacz ofertę"
                            >
                                <ExternalLinkIcon wrapperSize="2.4" size="2.4" />
                            </Button>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}

const list = css({
    listStyleType: "none",
    m: 0,
    p: 0,
    borderTop: "1px solid var(--colors-gray-300)",
    pt: 2
});

const listItem = css({
    mb: 2,
    position: "relative",
    overflow: "hidden"
});

const itemLinkOverlay = css({
    position: "absolute",
    inset: 0,
    zIndex: 1,

    _focusVisible: {
        outline: "1px solid -webkit-focus-ring-color",
        outlineOffset: "-2px"
    }
});

const itemContent = css({
    display: "flex",
    gap: 1
});

const contentWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    w: "100%"
});

const bulletDot = css({
    width: 1,
    height: 1,
    minWidth: "8px",
    minHeight: "8px",
    borderRadius: "50%",
    backgroundColor: "var(--colors-secondary)",
    marginTop: "5px",

    md: {
        marginTop: 1
    }
});

const externalLinkButton = css({
    width: "44px",
    height: "44px",
    color: "var(--colors-secondary)",
    backgroundColor: "var(--colors-gray-200)",
    cursor: "pointer",

    _hover: {
        opacity: 0.8
    }
});

const firstLine = css({
    display: "block"
});

const interactiveLayer = css({
    position: "relative",
    zIndex: 2
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ExternalLinkIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {SemanticSearchPropertyDto} from "../../types/SemanticSearchPropertyDto";
import {SemanticSearchConversationVoteButtons} from "../semantic_search_conversation/SemanticSearchConversationVoteButtons";

interface Props {
    properties?: SemanticSearchPropertyDto[][];
    apiMessageIndex: number;
}

function flattenProperties(properties: SemanticSearchPropertyDto[][]): SemanticSearchPropertyDto[] {
    return properties.flatMap((group) => group);
}

export function SemanticSearchPropertyList(props: Props) {
    const {properties, apiMessageIndex} = props;

    if (!properties || properties.length === 0) return null;

    const items = flattenProperties(properties);

    return (
        <ul className={list}>
            {items.map((property, index) => {
                const propertyLink = rpAppLink.property.detail.base({
                    vendorSlug: property.offer.vendor.slug,
                    offerSlug: property.offer.slug,
                    offerId: property.offer.id,
                    propertyId: property.id
                });

                return (
                    <li key={`${property.id}-${index}`} className={listItem}>
                        <a className={itemLinkOverlay} href={propertyLink} target="_blank" rel="noopener noreferrer" aria-label="Zobacz ofertę" />

                        <div className={itemContent}>
                            <span className={bulletDot} aria-hidden="true" />

                            <div className={contentWrapper}>
                                <Text variant="body_copy_1" as="span" className={firstLine}>
                                    {property.short_description}
                                </Text>

                                <div className={interactiveLayer}>
                                    <SemanticSearchConversationVoteButtons id={property.id} apiMessageIndex={apiMessageIndex} />
                                </div>
                            </div>

                            <Button
                                variant="none_secondary"
                                className={externalLinkButton}
                                href={propertyLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Zobacz ofertę"
                            >
                                <ExternalLinkIcon wrapperSize="2.4" size="2.4" />
                            </Button>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}

const list = css({
    listStyleType: "none",
    m: 0,
    p: 0,
    borderTop: "1px solid var(--colors-gray-300)",
    pt: 2
});

const listItem = css({
    mb: 2,
    position: "relative",
    overflow: "hidden"
});

const itemLinkOverlay = css({
    position: "absolute",
    inset: 0,
    zIndex: 1,

    _focusVisible: {
        outline: "1px solid -webkit-focus-ring-color",
        outlineOffset: "-2px"
    }
});

const itemContent = css({
    display: "flex",
    gap: 1
});

const contentWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    w: "100%"
});

const bulletDot = css({
    width: 1,
    height: 1,
    minWidth: "8px",
    minHeight: "8px",
    borderRadius: "50%",
    backgroundColor: "var(--colors-secondary)",
    marginTop: "5px",

    md: {
        marginTop: 1
    }
});

const externalLinkButton = css({
    width: "44px",
    height: "44px",
    color: "var(--colors-secondary)",
    backgroundColor: "var(--colors-gray-200)",
    cursor: "pointer",

    _hover: {
        opacity: 0.8
    }
});

const firstLine = css({
    display: "block"
});

const interactiveLayer = css({
    position: "relative",
    zIndex: 2
});
